// Module
var code = "<template> ${fullName} </template> ";
// Exports
export default code;